/* eslint-disable max-len */
import React, { useContext, useState } from 'react';
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, Grid, Stack, Typography } from '@mui/material';
import { LanguageContext } from '../../../../../../../../../libs/Context';
import { deleteCategory } from '../../../../../../../../actions/resource_configuration/category_management';
import { toast } from 'react-toastify';

interface CategoryDeletePopupProps {
	open: boolean;
	handleDialogClose: () => void;
	categoryName?: string;
	category?: any;
	contentData?: any;
	onDeleteSuccess?: () => void;
	isConfirmed?: boolean;
	handleConfirmChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	isDeleting?: boolean;
	handleDelete?: () => void;
	// content?: string;
	enableCheckbox?: boolean;
	subLabel?: string;
}

const CategoryDeletePopup = (props: CategoryDeletePopupProps) =>
{
	const {
		open,
		handleDialogClose,
		categoryName,
		category,
		contentData,
		onDeleteSuccess,
		isDeleting: externalIsDeleting,
		handleDelete: externalHandleDelete,
		isConfirmed: externalIsConfirmed,
		handleConfirmChange: externalHandleConfirmChange,
		enableCheckbox,
		subLabel
	} = props;

	const { language } = useContext(LanguageContext);

	// Local state for backward compatibility
	const [ localIsConfirmed, setLocalIsConfirmed ] = useState(false);
	const [ localIsDeleting, setLocalIsDeleting ] = useState(false);

	// Use either the external or local state
	const isConfirmed = externalIsConfirmed !== undefined ? externalIsConfirmed : localIsConfirmed;
	const isDeleting = externalIsDeleting !== undefined ? externalIsDeleting : localIsDeleting;

	// Local handlers for backward compatibility
	const handleConfirmChange = externalHandleConfirmChange || ((event: React.ChangeEvent<HTMLInputElement>) =>
	{
		event.stopPropagation();
		setLocalIsConfirmed(event.target.checked);
	});

	const handleDelete = externalHandleDelete || (async (e?: any) =>
	{
		if (e) e.stopPropagation();
		// if (!isConfirmed)
		// {
		// 	toast.error('Please confirm deletion by checking the box');
		// 	return;
		// }

		// Handle category deletion (original functionality for backward compatibility)
		if (category && category._id)
		{
			setLocalIsDeleting(true);

			try
			{
				// Perform the actual category deletion
				await deleteCategory(category._id);
				toast.success('Category deleted successfully');

				// Close the dialog first
				handleDialogClose();

				// Immediately call the callback for immediate UI update
				if (onDeleteSuccess)
				{
					onDeleteSuccess();
				}
			}
			catch (error)
			{
				console.error('Error deleting category:', error);
				toast.error('Failed to delete category');
			}
			finally
			{
				setLocalIsDeleting(false);
			}
		}
		// For content deletion or any other case, just close and call the callback
		else
		{
			handleDialogClose();

			if (onDeleteSuccess)
			{
				onDeleteSuccess();
			}
		}
	});

	return (
		<Dialog
			open={open}
			maxWidth='sm'
			disableEscapeKeyDown
			disableAutoFocus
			disableEnforceFocus
			onClose={(event, reason) =>
			{
				if (reason !== 'backdropClick' && reason !== 'escapeKeyDown')
				{
					handleDialogClose();
				}
			}}
		>
			<DialogContent onClick={(e) => e.stopPropagation()}>
				<Grid container direction={'column'} justifyContent={'center'} alignItems={'center'} onClick={(e) => e.stopPropagation()}>
					<Box width={'70px'} height={'70px'}>
						<img src='/images/icons/dialogPopup.svg' alt='dialog-popup' width={'100%'} height={'100%'}/>
					</Box>
					<Typography fontWeight={'var(--font500)'} pt={2} pb={1} color={'#737373'}>
						{`${language?.RusuretoDel} ${categoryName || category?.name || 'this item'}?`}
					</Typography>
					{(enableCheckbox || subLabel) &&
						<Stack
							direction={'row'}
							spacing={0.5}
							alignItems={'flex-start'}
							onClick={(e) => e.stopPropagation()}
						>
							{enableCheckbox &&
							<Checkbox
								checked={isConfirmed}
								onChange={handleConfirmChange}
								onClick={(e) => e.stopPropagation()}
							/>}
							{subLabel && <Typography pt={0.8}>{subLabel}</Typography>}
						</Stack>}
				</Grid>
			</DialogContent>
			<DialogActions>
				<Stack direction={'row'} px={2} pb={2} alignItems={'center'} spacing={2}>
					<Button
						variant='text'
						onClick={handleDelete}
						disabled={isDeleting}
					>
						{isDeleting ? 'Deleting...' : language?.delete || 'Delete'}
					</Button>
					<Button
						variant='contained'
						sx={{ color: 'var(--whiteColor)' }}
						onClick={handleDialogClose}
						disabled={isDeleting}
					>
						{language?.no || 'Cancel'}
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
};

export default CategoryDeletePopup;